export const LOGIN_ERROR_TYPES = [
  "ERROR",
  "PATIENT_NOT_FOUND",
  "TOO_MANY_ATTEMPTS",
  "GENERAL_ERROR",
  "UNREACHABLE",
];
